<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <admin-box-item title="FAQ 게시글 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="카테고리">
                  <lp-adm-drop-input ref="adminput"
                                     :data.sync="catArr"
                                     :selectVal="selectedCategory"
                                     @onSelect="res => board.category_id = res.value"
                                     placeholder="FAQ 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="FAQ 게시글 노출기간">
                  <div class="flex" style="flex-wrap:wrap">
                    <admin-date-picker
                      :data="board.start_date"
                      @setDate="selDateMin"></admin-date-picker>
                    <div class="lp-dating">&#126;</div>
                    <admin-date-picker
                          :data="board.end_date"
                          @setDate="selDateMax"></admin-date-picker>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시물 노출 여부" tip="게시글 노출 기간과 무관하게 노출/비노출을 설정할 수 있습니다.">
                  <lp-radio :val="board.enable_post"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'노출',value:true}, {label:'비노출', value:false}]"
                            @onSelect="onSelectedPostState"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="노출 우선순위" tip="숫자가 낮을 수록 우선순위가 높게 책정되어 먼저 표시되며, 노출 우선순위가 동일한 경우 최신등록순으로 표시됩니다.">
                  <input class="input"
                        :value="board.priority"
                        @input="e => board.priority = e.target.value"
                         placeholder="노출 우선순위를 입력하세요. (0~99)"
                        type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="질문">
                  <textarea class="textarea"
                            rows="10"
                            cols="10"
                            placeholder="질문을 입력하세요."
                            v-model="board.question"></textarea>
                  <!--<lp-editor :text.sync="board.question"></lp-editor>-->
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="답변">
                  <!--<textarea class="textarea"
                            rows="10"
                            cols="10"
                            placeholder="답변을 입력하세요."
                            v-model="board.answer"></textarea>-->
                  <lp-editor :text.sync="board.answer"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

  </div>
</template>

<script>
  import moment from "moment";
  import Datepicker from "vuejs-datepicker";
  import InputImg from "../../module/common/InputImg";
  import LpSelect from "../../module/common/LpSelect.vue";
  import TimeInfo from "../../module/common/TimeInfo.vue";
  import LpInputText from "../../module/common/LpInputText";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import LpAddress from "../../module/common/LpAddress";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpRadio from "../../module/common/LpRadio";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import LpEditor from "../../module/common/LpEditor";
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    layout: "Main",
    components: {
      LpEditor,
      InputImg,
      LpSelect,
      TimeInfo,
      Datepicker,
      LpInputText,
      LpSortDropDown,
      LpAddress,
      LpCheckBool,
      LpRadio,
      LpAdmDropInput
    },
    mixins: [
      CreateMixin
    ],
    created() {
      // 새로 등록
      if ( this.$route.query.id === undefined ) {
        /*this.board.start_date = this.resetNewDate('start');
        this.board.end_date = this.resetNewDate('end');
        this.board.username = this.$store.getters.admin.username;*/
      }
      // 라우팅
      else {
        this.getData();
      }
      this.getCategory();
    },
    data() {
      return {
        // 공지사항, 이벤트 ...
        board_name: '',
        board_type: '',
        // is_modify: false,
        board: {
          id: 0,
          board_id: 0,
          start_date: '',
          end_date: '',
          priority: 99,
          question: "",
          answer: "",
          username: "admin",
          is_secret: false,
          category_id: "",
          enable_post: true,
        },
        nowOpened: "",
        showCommentsList: true, // 댓글 목록 fold/unfold
        isNewCommentsReg: true, // true: 새댓글등록, false: 기존댓글수정
        updateIndex: undefined, // 수정 댓글 인덱스
        // 댓글 목록
        commentsArr: [],
        // 댓글 작성
        comments: {
          id: 0, // 상품문의상세 게시글 id
          writer: "",
          writer_type: "",
          writer_name: "",
          writer_username: "",
          date: "",
          content: "",
          lock: false // 비밀댓글 여부
        },
        // 댓글 작성자 드롭다운 Array
        commentsWriterArr: [],
        catArr: []
      };
    },
    computed: {
      selectedCategory() {
        let label = '';
        this.catArr.forEach(cat=>{
          if(cat.value===this.board.category_id) label = cat.label;
        })
        return label;
      }
    },
    methods: {
      // 게시판 노출 여부
      onSelectedPostState(val) {
        this.board.enable_post = val;
      },
      getData() {
        // if (this.is_modify) {
        this.$axios.get(this.getUrl('board/faq/' + this.$route.query.id))
        .then(res => {
          this.board = res.data;
          //console.log(res.data);
        });

      },
      // 삭제
      clickDelete(idx) {
        let url = '';
        if (this.$store.getters.mode === 'admin') {
          url = 'admin/partner/comment';
        }
        else {
          url = 'partner/' + this.$store.getters.partner.partner_id + '/comment';
        }

        this.$axios.get(url + '?id=' + this.commentsArr[idx].id)
          .then(() => {
            this.commentsArr.splice(idx, 1);
          });
      },
      selDateMin(val) {
        this.board.start_date = val;
      },
      selDateMax(val) {
        this.board.end_date = val;
      },
      priorityKeyUp(value) {
        this.board.priority = value;
      },
      done() {
        let url = this.getUrl('board/faq');

        let value = this.cloneItem(this.board);
        if(!value.start_date){
          value.start_date = '1111-01-01';
        }
        if(!value.end_date){
          value.end_date = '9999-01-01';
        }
        if (this.$route.query.id) {
          this.$axios.patch(url + '/' + this.$route.query.id, value).then(res => {
            if (res.status === 200) {
              this.toast("저장되었습니다.");
              this.$router.replace(this.getPath("faq"));
            }
          });
        }
        else {
          this.$axios.post(url, value).then(res => {
            if (res.status === 200) {
              this.toast("저장되었습니다.");
              this.$router.replace(this.getPath("faq"));
            }
          });
        }
      },
      getCategory() {
        this.$axios.get('public/board/faq/category').then(res=> {
          this.catArr = res.data;
        })
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  //@import '~assets/css/lp_main';

  .comment-sub-title {
    background: #ddd;
    color: #333;
    padding: 8px 16px;
    font-size: 0.95rem;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
  }

  .board-comment-content {
    padding: 20px;
    font-size: 0.95rem;
    color: #222;
    border-radius: 3px;
    border: none;
    background-color: #f2f7f8;
    display: block;
    width: 100%;
    height: 120px;
  }

  .btn-add-img {
    margin: 0 8px 8px 0;
    background: #f2f7f8;
    width: 80px;
    height: 80px;
    text-align: center;
  }

  .btn-add-img i {
    font-size: 3rem;
    line-height: 80px;
    color: #555;
  }
</style>
